import { Helmet } from "react-helmet-async";
import ServiceLayout from "./ServiceLayout";
import { Typography, Box } from "@mui/material";


const PotsSupply = () => {
  return (
    <>
      <Helmet>
        <title>Pots Supply | KRM Landscape</title>
        <meta
          name="description"
          content="Premium decorative pots and planters supplied by KRM Landscape, suitable for homes, offices, and commercial landscapes."
        />
        <meta
          name="keywords"
          content="Pots Supply, Decorative Pots, Planters, KRM Landscape, Garden Pots, Commercial Landscape Pots"
        />
      </Helmet>

      <ServiceLayout title="Pots Supply">

        {/* Hero Image */}
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Box
            component="img"
            src="/images/pots.jpg"
            alt="Pots Supply by KRM Landscape"
            sx={{
              width: { xs: "100%", md: "80%" },
              maxHeight: "400px",
              objectFit: "contain",
              borderRadius: "12px",
              mx: "auto",
              display: "block",
            }}
          />
        </Box>

        <Typography paragraph>
          KRM Landscape offers a wide selection of high-quality pots designed to
          complement every type of plant and space. Our pots are carefully chosen
          to balance durability, functionality, and aesthetic appeal.
        </Typography>

        <Typography paragraph>
          Our range includes ceramic, terracotta, fiberglass, plastic, metal,
          and decorative planters in various sizes, shapes, and finishes.
          Whether your style is modern, classic, minimal, or natural,
          we provide options that seamlessly blend with your environment.
        </Typography>

        <Typography paragraph>
          From home gardens and balconies to offices, hotels, and large landscape
          projects, our pots are designed to support plant health while enhancing
          the overall visual impact. Proper drainage, material quality, and
          long-lasting performance are always our priorities.
        </Typography>

        <Typography paragraph>
          With KRM Landscape’s pot supply services, you get more than containers, 
          you get thoughtfully selected planters that elevate the beauty,
          structure, and longevity of your green spaces.
        </Typography>

      </ServiceLayout>
    </>

  );
};

export default PotsSupply;
